import { NextSessions } from './NextSessions';

export const PsychologistHome = (): React.ReactElement => (
  <div className="flex flex-col gap-8 max-w-6xl mx-auto mt-10">
    <NextSessions />
  </div>
);
